export default __webpack_public_path__ + "media/b42f8ef3ef602644b3e82593e847387457b0daa617f6f71a29b061c8dea9e01c.svg";